import * as React from 'react';
import styles from './WrapperOtherPosts.module.sass';

export const WrapperOtherPosts: React.FunctionComponent<
  React.PropsWithChildren
> = ({ children }) => (
  <div className={styles.WrapperOtherPosts}>{children}</div>
);
